import React from "react";
import { CustomSelect } from "../CustomFields";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { useReportMonk } from "../../context/reportMonk";
import { responsive, breakpoints } from "../../utils/style";
import { Select } from "antd";
import WeekTotalScore from "./WeekTotalScore";
import WeekResult from "./WeekResult";
import { getRewards, getLastReward } from "../../utils/reward";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import {
  SelectLabel,
  SelectContainer,
  TotalScoreContainer,
} from "./shareStyledComponents";

const { Option } = Select;

const properties = {
  infinite: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: false,
  indicators: false,
  arrows: false,
  responsive: [
    {
      breakpoint: breakpoints.tablet,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6,
      },
    },
    {
      breakpoint: breakpoints.mobile,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6,
      },
    },
  ],
};

const WeekTabResult = () => {
  const {
    mode,
    setMode,
    getWeekOptions,
    selectedWeekIndex,
    setSelectedWeekIndex,
    haveRewards,
    getCurrentWeekRewards,
    getCurrentWeekOtherRewards,
    isSelectedWeek,
  } = useReportMonk();
  return (
    <SelectContainer>
      <SelectLabel>มุมมอง</SelectLabel>
      <br />
      <CustomSelect
        width={"440px"}
        widthRs={"100%"}
        onChange={(v) => setMode(v)}
        placeholder="เลือกมุมมอง"
        defaultValue={mode}
      >
        <Option value={"weeks"}>รายสัปดาห์</Option>
        <Option value={"cumulativeWeeks"}>ผลรวมสะสมถึงสัปดาห์</Option>
      </CustomSelect>
      <SelectLabel>สัปดาห์</SelectLabel>
      <CustomSelect
        width={"440px"}
        widthRs={"100%"}
        placeholder="เลือกสัปดาห์"
        //style={{ width: "100%", borderRadius: "4px" }}
        onChange={(v) => setSelectedWeekIndex(v)}
        // defaultValue={selectedWeekIndex}
        value={selectedWeekIndex}
      >
        {getWeekOptions().map((o, i) => {
          return (
            <Option value={o.value} key={`week-options-${i}`}>
              {o.name}
            </Option>
          );
        })}
      </CustomSelect>

      {isSelectedWeek() && (
        <>
          <TotalScoreContainer>
            <WeekTotalScore />
          </TotalScoreContainer>
          {haveRewards() && getCurrentWeekRewards().length > 1 && (
            <OtherRewardsContainer>
              <OtherRewardsText>
                และ {getCurrentWeekOtherRewards().length} รางวัลอื่นๆ ที่ได้รับ
              </OtherRewardsText>
              <Slide {...properties}>
                {getRewards(getCurrentWeekOtherRewards()).map((r) => {
                  return (
                    <OtherRewardContainer>
                      <img
                        src={require("../../assets/images/badges/" + r.image)}
                        width={"100%"}
                      />
                    </OtherRewardContainer>
                  );
                })}
              </Slide>
            </OtherRewardsContainer>
          )}
          <WeekResult />
        </>
      )}
    </SelectContainer>
  );
};

const OtherRewardContainer = styled.div`
  width: 115px;
  height: 110px;
  padding: 5px;

  border-radius: 16px;
  border: 1px solid #e7eaee;
  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.1));
`;

const OtherRewardsContainer = styled.div`
  width: 770px;
  height: 160px;
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  justify-content: unset;

  ${responsive.tablet(css`
    max-width: 834px;
    margin-left: 32px;
    margin-right: 32px;
  `)}

  ${responsive.mobile(css`
    width: 100%;
    max-width: 375px;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 20px;
  `)}
`;

const OtherRewardsText = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 26px;
  color: #64748b;

  margin-left: 16px;
`;

export default WeekTabResult;
